/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import { showNotification } from 'Store/Notification/Notification.action';
import { isSignedIn } from 'Util/Auth';
import { getGuestQuoteId } from 'Util/Cart';
import { fetchQuery } from 'Util/Request';

import ExtraFeeQuery from '../../query/ExtraFee.query';
import { updateExtraFee } from './ExtraFee.action';

export const CartDispatcher = import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    'Store/Cart/Cart.dispatcher'
);

/** @namespace Mirat/Extrafee/Store/ExtraFee/Dispatcher */
export class ExtraFeeDispatcher {
    prepareRequest(customerId, dispatch) {
        const quoteId = isSignedIn() ? '' : this._getGuestQuoteId(dispatch);

        const query = ExtraFeeQuery.getQuery(quoteId, customerId);
        return fetchQuery(query).then(
            /** @namespace Mirat/Extrafee/Store/ExtraFee/Dispatcher/ExtraFeeDispatcher/prepareRequest/fetchQuery/then */
            (data) => {
                dispatch(updateExtraFee(data));
            },
            /** @namespace Mirat/Extrafee/Store/ExtraFee/Dispatcher/ExtraFeeDispatcher/prepareRequest/fetchQuery/then/catch */
            (error) => {
                dispatch(showNotification('error', __('Error fetching ExtraFee!'), error));
            }
        );
    }

    /**
     * Get quote id. If quote id is missing, fetch it from the BE.
     * @param Dispatch dispatch
     * @return string quote id
     */
    _getGuestQuoteId(dispatch) {
        const guestQuoteId = getGuestQuoteId();

        if (guestQuoteId) {
            return guestQuoteId;
        }

        return CartDispatcher.then(({ default: dispatcher }) => dispatcher.createGuestEmptyCart(dispatch));
    }
}

export default new ExtraFeeDispatcher();
